import React, { Component } from 'react'
import SEO from '../../../components/seo'

import axios from 'axios'

import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Table from 'react-bootstrap/Table'

import Layout from '../../../components/layout/layout'
import NextPreviousRow from '../../../components/next-previous'
import PageTitle from '../../../components/page-title'

import isUserSignedIn from '../../../auth/is-user-signed-in'

import StudentContent from '../../../components/layout/student-content'
import TeacherContentStudentAccordion from '../../../components/layout/teacher-content/teacher-content-student-accordion'
import TeacherContentTeacherAccordion from '../../../components/layout/teacher-content/teacher-content-teacher-accordion'
import Video from '../../../components/video'

// eslint-disable-next-line
import threedmssImage from '../../../queries/threedmssImage'

const Page = class extends Component {
  constructor(props) {
    super(props)

    this.state = {
      student_accordion_open: true,
      authenticated: undefined
    }

    this.axios_cancel_token = axios.CancelToken.source()
  }

  async componentDidMount () {
    const is_signed_in = isUserSignedIn()
    this.setState({authenticated: is_signed_in})
  }

  render() {
    const { location } = this.props
    if (this.state.authenticated === undefined) {
      return (
        <React.Fragment>
          <Layout>
            <Container fluid className="d-flex h-100 flex-column pt-3">
              <Row className="mb-3 justify-content-center w-100">
                <div className="spinner-grow text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </Row>
            </Container>
          </Layout>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <SEO title="Systems Working Together: Preparation" />
          <Layout
            location={location}
            course="threedmss"
            setStudentAccordionState={(state) => this.setState({student_accordion_open: state})}
            setAuthenticated={(is_signed_in) => this.setState({authenticated: is_signed_in})}
          >
            <Container fluid className="d-flex h-100 flex-column pt-3">
              <PageTitle title="Systems Working Together: Preparation" no_breadcrumb={true} />
              <Row style={{ marginBottom: '2rem' }}>
                {this.state.authenticated &&
                  <React.Fragment>
                    <Col xs={12} lg={6} id="student-accordion-column">
                      <TeacherContentStudentAccordion
                        title="Student View"
                        open={this.state.student_accordion_open}
                        setStudentAccordionState={() => {
                          /*
                            Anytime this is called, it's toggling so I'm just setting it to the opposite of its current state. This is to sync the student accordion state with the ToggleStudentView component.  Pretty much just don't worry about it. Keep walking.
                          */
                          if (this.state.student_accordion_open) {
                            this.setState({student_accordion_open: false})
                          } else {
                            this.setState({student_accordion_open: true})
                          }
                        }}
                      >
                        <div className="row">
                          <div className="col-12">
                            <hr className="focus-question-heading bold-me d-none d-md-block d-lg-none d-xl-block" />
                            <h3 className="bold-me d-block d-md-none d-lg-block d-xl-none text-center">Focus Question</h3>
                            <hr className="d-block d-md-none d-lg-block d-xl-none" />
                            <p className="focus-question bold-me">When and how do body systems work together?</p>
                            <hr className="after-focus-question" />
                          </div>

                          <div className="col-12">
                            <p>In the previous lesson, you shared what you know about how body systems interact with one another. The connections among body systems may be one reason you can use to explain why M'Kenna is having symptoms throughout her body. But, we need to know more about the connections among systems to explain all that is happening in M'Kenna.</p>

                            <p>One way to observe how body systems interact is to monitor them. You learned that glucose comes from digesting food that we eat. Measuring blood glucose can tell you what might be happening related to the digestive system because it tells you how much glucose is circulating in the bloodstream and is available to cells. Determining breathing rate and heart rate are other ways to measure what is happening with body systems. Calculating the amount of calories burned is a way to estimate the amount of energy required for different activities. You already know that when people are more active their body systems are working faster to bring glucose and oxygen to cells.</p>

                            <p>In this activity, you will collect data to monitor how glucose levels, breathing rate, heart rate, and calories burned change with different daily activities.</p>
                          </div>
                        </div>

                        <div className="col-12">
                          <hr className="notebook-icon my-5" />
                          <span className="sr-only">Notebook Icon</span>
                          <h3 className="section-heading bold-me">Prepare for collecting data in the Body Systems interactive.</h3>

                          <p className="list-heading bold-me underline-me my-4">On your own</p>
                          <ol>
                            <li>Title a new page in your science notebook "Systems Working Together."</li>
                            <li>Draw a table to organize your ideas. Use the example below.</li>
                          </ol>

                          <p className="handwriting text-center"><span className="bold-me">Systems Working Together</span></p>

                          <Table responsive className="bscs-table handwriting" style={{tableLayout:'fixed',width:'100%'}}>
                            <thead>
                              <tr >
                                <th scope="col" className="notebook-table-th" style={{fontSize: '10px', width: '25%'}}>
                                  <span className="sr-only">Molecule</span>
                                  Data measurement
                                </th>
                                <th scope="col" className="notebook-table-th" style={{fontSize: '10px', width: '25%'}}>
                                  <span className="sr-only">List the body systems related to this measurement</span>
                                  List the body systems related to this measurement
                                </th>
                                <th scope="col" className="notebook-table-th" style={{fontSize: '10px', width: '25%'}}>
                                  <span className="sr-only">If the values of the data go up, what might be happening?</span>
                                  If the values of the data go up, what might be happening?
                                </th>
                                <th scope="col" className="notebook-table-th" style={{fontSize: '10px', width: '25%'}}>
                                  <span className="sr-only">If the values of the data go down, what might be happening?</span>
                                  If the the values of the go down, what might be happening?
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Blood glucose</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                              </tr>
                              <tr>
                                <td>Calories burned</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                              </tr>
                              <tr>
                                <td>Heart rate</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                              </tr>
                              <tr>
                                <td>Breathing rate</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                              </tr>
                            </tbody>
                          </Table>

                          <ol start="3">
                            <li>For each data measurement, write your ideas about the body systems that may be related to the data.</li>
                            <li>For each data measurement, write your ideas about what could be happening if the values of the data go up or go down.</li>
                          </ol>

                          <p className="list-heading bold-me underline-me my-4">With your team</p>
                          <ol start="5">
                            <li>Discuss your ideas with your team. You can add to or revise your ideas as you hear new information from your team.</li>
                            <li>Review the Focus Question, <span className="italic">When and how do body systems work together?</span> Discuss with one another how collecting this information can help you answer the Focus Question.</li>
                          </ol>
                        </div>
                      </TeacherContentStudentAccordion>
                    </Col>
                    <Col xs={12} lg={6} name="teacher-accordion-column">
                      <Container fluid>
                        <Row>
                          <TeacherContentTeacherAccordion title="Time Estimate" open={true}>
                            <p>Estimated time to complete this web page: 10 min</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Before You Teach">
                            <p>Print these handouts:</p>
                            <ul>
                              <li><a href="https://media.bscs.org/3dmss/te/documents/04_tog/systems_working_together_data.pdf" target="_blank" rel="noopener noreferrer" className="italic">Systems Working Together Data&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></li>
                              <li><a href="https://media.bscs.org/3dmss/te/documents/04_tog/fasting_comparison_data.pdf" target="_blank" rel="noopener noreferrer" className="italic">Fasting Comparison Data&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></li>
                              <li><a href="https://media.bscs.org/3dmss/te/documents/04_tog/body_systems_model_gotta-have-it_checklist.pdf" target="_blank" rel="noopener noreferrer" className="italic">Body Systems Model: Gotta-Have-It Checklist&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></li>
                              <li><a href="https://media.bscs.org/3dmss/te/documents/04_tog/model_systems_working_together.pdf" target="_blank" rel="noopener noreferrer" className="italic">Model: Systems Working Together&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></li>
                            </ul>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Where are we in the storyline?">
                            <p><span className="bold-me">Storyline for Disciplinary Core Ideas (DCIs)</span></p>

                            <p>Students have gathered a good deal of evidence across the unit to explain M'Kenna's symptoms. They know that her small intestine is damaged and has flattened villi. They know that having flattened villi results in less absorption of nutrients, as fewer nutrients move from inside her small intestine out to other parts of her body. Her cells are using nutrients from body stores, which is causing her weight loss. They know all cells need nutrients and use these nutrients at a faster rate when they are more active. Students do not yet have a complete explanation for how M'Kenna can have symptoms all over her body if the damage is in her digestive system. In the Engage, Explore, and Explain activities of this chapter, students look carefully at two systems interacting to see how damage to the digestive system can cause symptoms in another system.</p>

                            <p><span className="bold-me">Storyline for Science and Engineering Practices (SEPs)</span></p>

                            <p>The two focal practices for the unit, modeling and arguing from evidence, continue through this lesson.The practice of constructing explanations is also added in this chapter. However, modeling is the primary focal practice for Chapter 4 and arguing from evidence becomes less emphasized as students move from argument to using their models to construct scientific explanations.</p>

                            <p>In Lesson 2, students develop  their models of interactions in the human body and note which of M'Kenna's symptoms their model explains and which symptoms their model does not explain well. They make model-based predictions and revise their models to include what they learn about how body systems work together.</p>

                            <p><span className="bold-me">Storyline for Crosscutting Concepts (CCCs)</span></p>

                            <p>The concept of energy and matter is the focal crosscutting concept of this chapter. Students model and explain that matter is transported into and out of multiple body systems. They use the idea that the transfer of energy from cellular respiration drives the cycling of matter throughout these systems.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Phenomenon for This Lesson">
                            <p>M'Kenna has symptoms in more than one body system.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Main Learning Goal" open={true}>
                            <p>The body is a system of interacting subsystems composed of groups of cells. Molecules move into and out of the body and into and out of cells. Body systems work together to transport molecules between systems and between cells. Every cell in every body system relies on this transport.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Teacher Moves During Lesson: Steps 1-4" open={true}>
                            <div className="row">
                              <div className="col-12 mb-4">
                                <hr style={{margin: '10px 0'}} />
                                <div className="text-center">
                                  {/* For multiple icons: Every icon except the last one should have margin-right: 1rem; */}
                                  {/* For a single icon, leave margin-right: 1rem; out all together. */}
                                  <img src="https://media.bscs.org/3dmss/te/icons/stella-strategy-f-icon.svg" alt="STeLLA Strategy F" style={{width: '42px'}} />
                                  <span className="sr-only">STeLLA Strategy F Icon</span>
                                </div>
                                <hr style={{margin: '10px 0'}} />
                              </div>

                              <div className="col-12 mb-4">
                                <span className="sr-only">STeLLA Strategy F icon</span>
                                <h3 className="section-heading bold-me text-center"><a href="https://media.bscs.org/3dmss/te/documents/01_dig/stella_strategies_booklet_2018.pdf#page=57" target="_blank" rel="noopener noreferrer">Make explicit links between ideas and activities <span className="italic">before</span> the activity.&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></h3>
                              </div>

                              <ol type="A">
                                <li>On the next page, students will gather data from an interactive that shows how multiple body systems respond to changes in activity level. Before students start, it's vital that they consider the changes they might expect to see and why they think those changes would occur. By helping students link ideas to the activity <span className="italic">before</span> they begin the activity, they will develop a greater understanding of what the data mean.</li>
                                <li>In <span className="bold-me">steps 1-4</span>, students work independently to make predictions about how blood glucose, calories burned, heart rate, and breathing rate are influenced by activity levels.</li>
                              </ol>
                            </div>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Teacher Moves During Lesson: Steps 5-6">
                            <ol type="A" start="3">
                              <li>In <span className="bold-me">steps 5-6</span>, students share their ideas with their team and discuss how the data they collect will help them answer the Focus Question <span className="italic">When and how do body systems work together?</span> Listen carefully as students make predictions and challenge them to think about how body systems might work together to support these changes.</li>
                            </ol>

                            <p><span className="bold-me">Support for Struggling Learners:</span> Students that struggle to analyze and interpret data will benefit from contributing to and hearing team predictions about the data. Thinking ahead by predicting and trying to explain anticipated trends in the data provides a necessary scaffold for struggling learners.</p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Opportunity for English Language Arts Connection">
                            <p>This lesson provides an opportunity to integrate English language arts with science. Students should be able to read and comprehend the science text on this page independently and proficiently.</p>
                            <p><a href="http://www.corestandards.org/ELA-Literacy/RST/6-8/10/" target="_blank" rel="noopener noreferrer">CCSS.ELA-Literacy.RST.6-8.10&nbsp;<sup><i style={{fontSize: '.65rem'}} className="fas fa-external-link-alt"/></sup></a></p>
                          </TeacherContentTeacherAccordion>

                          <TeacherContentTeacherAccordion title="Classroom Video from This Lesson">
                            <div className="row">
                              <div className="col-12">
                                <hr style={{margin: '10px 0'}} />
                                <div className="text-center">
                                  {/* For multiple icons: Every icon except the last one should have margin-right: 1rem; */}
                                  {/* For a single icon, leave margin-right: 1rem; out all together. */}
                                  <img src="https://media.bscs.org/3dmss/te/icons/video-ant-icon.svg" alt="Video Ant icon." style={{width: '42px'}} />
                                </div>
                                <hr style={{margin: '10px 0'}} />
                              </div>
                              <div className="col-12">
                                <span className="sr-only">Video Ant Icon</span>
                                <h3 className="section-heading bold-me my-4" style={{textAlign: 'center'}}>Classroom video from this lesson.</h3>
                              </div>
                            </div>

                            <p className="bold-me">Video 1 Summary</p>
                            <p>This video shows a teacher setting up the Explore: Systems Working Together activity by asking students to link the activity they are about to do with important science ideas they will be learning. Students are linking what they are doing in the activity with science ideas about body systems. The class also discusses monitoring body systems.</p>

                            <Video vimeo_id="353002428" />

                            <p><a href="https://media.bscs.org/3dmss/te/documents/04_tog/3dmss_tevid_ch4_1_lia_before_transcript.pdf" target="_blank" rel="noopener noreferrer">Transcript&nbsp;<sup><i style={{fontSize: '.65rem'}} className="fas fa-external-link-alt"/></sup></a></p>

                            <p><span className="bold-me">Video 2 Summary</span></p>
										        <p>This video shows students linking ideas to an activity before they participate in the activity. In the activity, Systems Working Together (Chapter 4 Explore) students will examine data about Ben's blood glucose levels, heart rate, respiratory rate, and calories burned to see how the body responds during different levels of activity. But first, students think about what it would mean if these measures increase or decrease. The students are now completing a handout that asks them to connect blood glucose, heart rate, respiratory rate, and calories burned to the body system these measurements might be related to. Students are working in groups to link science ideas to the Systems Working Together activity before actually participating.</p>

                            <Video vimeo_id="353002672" />

                            <p><a href="https://media.bscs.org/3dmss/te/documents/04_tog/3dmss_tevid_ch4_2_lia_before2_transcript.pdf" target="_blank" rel="noopener noreferrer">Transcript&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></p>

                            <p><span className="bold-me">Video 3 Summary</span></p>
										        <p>This video shows students revealing more ideas before they participate in the activity in the Explore of Chapter 4. The students are making predictions about what the data might mean when certain measures go up or down. The measures are blood glucose, heart rate, respiration rate, and calories burned. These measurements were taken while Ben did various levels of activity and ate normal meals.</p>

                            <Video vimeo_id="353002959" />

                            <p><a href="https://media.bscs.org/3dmss/te/documents/04_tog/3dmss_tevid_ch4_3_lia_before3_transcript.pdf" target="_blank" rel="noopener noreferrer">Transcript&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></p>

                            <p><span className="bold-me">Video 4 Summary</span></p>
										        <p>This video shows Ms. Jadamiec and her class discussing the predictions her students made on the data sheet about what it might mean if each of the measurements taken for Ben either increased or decreased. Then, Ms. Jadamiec asks elicit questions and probe questions of the class to learn more about what the students are thinking. There is also evidence of the class using and the teacher encouraging Communicating in Scientific Ways.</p>

                            <Video vimeo_id="353003233" />

                            <p><a href="https://media.bscs.org/3dmss/te/documents/04_tog/3dmss_tevid_ch4_4_e_p_csw_transcript.pdf" target="_blank" rel="noopener noreferrer">Transcript&nbsp;<sup><i  style={{fontSize: '.65rem'}}  className="fas fa-external-link-alt"></i></sup></a></p>
                          </TeacherContentTeacherAccordion>
                        </Row>
                      </Container>
                    </Col>
                  </React.Fragment>
                }
                {!this.state.authenticated &&
                  <StudentContent>
                    <div className="row">
                      <div className="col-12">
                        <hr className="focus-question-heading bold-me" />
                        <p className="focus-question bold-me">When and how do body systems work together?</p>
                        <hr className="after-focus-question" />
                      </div>

                      <div className="col-12">
                        <p>In the previous lesson, you shared what you know about how body systems interact with one another. The connections among body systems may be one reason you can use to explain why M'Kenna is having symptoms throughout her body. But, we need to know more about the connections among systems to explain all that is happening in M'Kenna.</p>

                        <p>One way to observe how body systems interact is to monitor them. You learned that glucose comes from digesting food that we eat. Measuring blood glucose can tell you what might be happening related to the digestive system because it tells you how much glucose is circulating in the bloodstream and is available to cells. Determining breathing rate and heart rate are other ways to measure what is happening with body systems. Calculating the amount of calories burned is a way to estimate the amount of energy required for different activities. You already know that when people are more active their body systems are working faster to bring glucose and oxygen to cells.</p>

                        <p>In this activity, you will collect data to monitor how glucose levels, breathing rate, heart rate, and calories burned change with different daily activities.</p>
                      </div>
                    </div>

                    <div className="col-12">
                      <hr className="notebook-icon my-5" />
                      <span className="sr-only">Notebook Icon</span>
                      <h3 className="section-heading bold-me">Prepare for collecting data in the Body Systems interactive.</h3>

                      <p className="list-heading bold-me underline-me my-4">On your own</p>
                      <ol>
                        <li>Title a new page in your science notebook "Systems Working Together."</li>
                        <li>Draw a table to organize your ideas. Use the example below.</li>
                      </ol>

                      <p className="handwriting text-center"><span className="bold-me">Systems Working Together</span></p>

                      <div className="responsive-table-wrapper">
                        <Table responsive className="bscs-table handwriting">
                          <thead>
                            <tr style={{width: '33%'}}>
                              <th scope="col" className="notebook-table-th">
                                <span className="sr-only">Molecule</span>
                                Data measurement
                              </th>
                              <th scope="col" className="notebook-table-th">
                                <span className="sr-only">List the body systems related to this measurement</span>
                                List the body systems related to this measurement
                              </th>
                              <th scope="col" className="notebook-table-th">
                                <span className="sr-only">If the values of the data go up, what might be happening?</span>
                                If the values of the data go up, what might be happening?
                              </th>
                              <th scope="col" className="notebook-table-th">
                                <span className="sr-only">If the values of the data go down, what might be happening?</span>
                                If the the values of the go down, what might be happening?
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Blood glucose</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                            </tr>
                            <tr>
                              <td>Calories burned</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                            </tr>
                            <tr>
                              <td>Heart rate</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                            </tr>
                            <tr>
                              <td>Breathing rate</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>

                      <ol start="3">
                        <li>For each data measurement, write your ideas about the body systems that may be related to the data.</li>
                        <li>For each data measurement, write your ideas about what could be happening if the values of the data go up or go down.</li>
                      </ol>

                      <p className="list-heading bold-me underline-me my-4">With your team</p>
                      <ol start="5">
                        <li>Discuss your ideas with your team. You can add to or revise your ideas as you hear new information from your team.</li>
                        <li>Review the Focus Question, <span className="italic">When and how do body systems work together?</span> Discuss with one another how collecting this information can help you answer the Focus Question.</li>
                      </ol>
                    </div>
                  </StudentContent>
                }
              </Row>
              <NextPreviousRow location={location} authenticated={this.state.authenticated} />
            </Container>
          </Layout>
        </React.Fragment>
      )
    }
  }
}

export default Page
